import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { reducer as formReducer } from 'redux-form';
import Immutable from 'seamless-immutable';
import { FORM_UTILS } from '@widergy/web-utils';

import AnalyticsMiddleware from '../services/AnalyticsService';

import { reducer as user } from './user/reducer';
import { reducer as auth, actions as authActions } from './authHandlers';
import { reducer as account } from './accountHandlers';
import { reducer as voucher } from './voucherHandlers';
import { reducer as point } from './pointHandlers';
import { reducer as payment, defaultState as paymentDefault } from './paymentHandlers';
import { reducer as alert } from './alertHandlers';
import { reducer as userForm } from './userFormHandlers';
import { reducer as bill } from './bill/reducer';
import { reducer as tip } from './tipHandlers';
import { reducer as notification } from './notificationHandlers';
import { reducer as device } from './deviceHandlers';
import { reducer as utility } from './utility/reducer';
import { reducer as customProcedures } from './customProceduresHandlers';
import { reducer as survey } from './survey/reducer';

export const history = createBrowserHistory();

const form = formReducer.plugin({
  UTFORM: FORM_UTILS.deleteValue,
  ENTITIES_COMPLAINT: FORM_UTILS.deleteValue,
  CHANGE_USER_INFO: FORM_UTILS.deleteValue
});

const reducers = combineReducers({
  auth,
  user,
  form,
  alert,
  account,
  voucher,
  point,
  router: connectRouter(history),
  userForm,
  bill,
  tip,
  notification,
  device,
  utility,
  customProcedures,
  survey,
  payment
});

const middlewares = [routerMiddleware(history)];
const enhancers = [];

/* ------------- Thunk Middleware ------------- */
middlewares.push(thunk);

/* ------------- Analytics Middleware ------------- */
middlewares.push(AnalyticsMiddleware);

/* ------------- Assemble Middleware ------------- */
enhancers.push(applyMiddleware(...middlewares));

const composeEnhancers =
  // eslint-disable-next-line no-underscore-dangle
  (process.env.NODE_ENV === 'development' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const getGlobalState = state =>
  Immutable({
    auth: { sessionLoading: false, enteredUrl: state.auth && state.auth.enteredUrl },
    utility: { healthCheck: state.utility && state.utility.healthCheck },
    payment: paymentDefault
  });

const rootReducer = (state, action) => {
  if (action.type === authActions.SIGN_OUT) {
    const newState = getGlobalState(state);
    return reducers(
      { ...newState, form: state.form, alert: state.alert, device: state.device, router: state.router },
      action
    );
  }
  return reducers(state, action);
};

const store = createStore(rootReducer, composeEnhancers(...enhancers));

export default store;
